import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle, FiPhone, FiMail, FiX, FiMessageSquare } = FiIcons;

const QuickContact = () => {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      icon: FiPhone,
      label: 'Appeler',
      action: 'tel:+237699187929',
      color: 'bg-green-500',
    },
    {
      icon: FiMessageCircle,
      label: 'WhatsApp',
      action: 'https://wa.me/237699187929',
      color: 'bg-green-600',
    },
    {
      icon: FiMail,
      label: 'Email',
      action: 'mailto:contact@mam-consulting.biz',
      color: 'bg-blue-600',
    },
  ];

  return (
    <div className="fixed right-6 bottom-6 z-50 flex flex-col items-end gap-4">
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 20, scale: 0.8 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 20, scale: 0.8 }}
            className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-4 mb-2 w-64 border border-gray-100 dark:border-gray-700"
          >
            <h3 className="text-sm font-bold text-gray-500 dark:text-gray-400 mb-3 uppercase tracking-wider">
              Contact Rapide
            </h3>
            <div className="space-y-3">
              {contactOptions.map((option, index) => (
                <a
                  key={index}
                  href={option.action}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center p-3 rounded-xl hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors group"
                >
                  <div
                    className={`w-10 h-10 ${option.color} rounded-full flex items-center justify-center text-white shadow-md group-hover:scale-110 transition-transform`}
                  >
                    <SafeIcon icon={option.icon} className="w-5 h-5" />
                  </div>
                  <span className="ml-3 font-semibold text-gray-700 dark:text-gray-200">
                    {option.label}
                  </span>
                </a>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        onClick={() => setIsOpen(!isOpen)}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className={`flex items-center justify-center h-14 px-6 rounded-full shadow-lg transition-all ${
          isOpen
            ? 'bg-gray-200 dark:bg-gray-700 text-gray-800 dark:text-white'
            : 'bg-gradient-to-r from-blue-600 to-cyan-500 text-white'
        }`}
      >
        <SafeIcon
          icon={isOpen ? FiX : FiMessageSquare}
          className={`w-6 h-6 ${isOpen ? '' : 'mr-2'}`}
        />
        {!isOpen && <span className="font-semibold">Contact Rapide</span>}
      </motion.button>
    </div>
  );
};

export default QuickContact;